const Pressability = {},
  usePressability = e => ({});
export { Pressability, usePressability };
//# sourceMappingURL=Pressability.mjs.map
